import { Navigate } from "react-router-dom";

/**
 * The bare root has no quote slug, so there's nothing public to show. Send
 * visitors to the staff console (which itself gates to login). Public quotes
 * are always reached via their unguessable /<slug> link.
 */
export function LandingRedirect() {
  return <Navigate to="/staff" replace />;
}
